(function () {
  'use strict';
  const DESTINATION = 'G-00PNFVMHHK';
  const PREFIX = 'gccv-confirmed-lead-v1:';
  const TTL = 30 * 60 * 1000;
  const FORMS = Object.freeze({CampervanQuoteForm: 'quote'});
  function install(win, doc) {
    if (doc.documentElement.dataset.gccvLeadTracking) return;
    doc.documentElement.dataset.gccvLeadTracking = '1';
    let timer = null;
    let deadline = 0;
    let requestedPrivacy = false;
    const consumed = new Set();
    const committedHandoffs = new WeakSet();
    function allowed() {
      try { return win.Shopify && win.Shopify.customerPrivacy && win.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
      catch (_) { return false; }
    }
    function privacyKnown() {
      return !!(win.Shopify && win.Shopify.customerPrivacy && typeof win.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function');
    }
    function remove(id) {
      try { win.sessionStorage.removeItem(PREFIX + id); return win.sessionStorage.getItem(PREFIX + id) === null; }
      catch (_) { return false; }
    }
    function dropAll() {
      Object.keys(FORMS).forEach(id => { try { win.sessionStorage.removeItem(PREFIX + id); } catch (_) {} });
      if (timer) win.clearTimeout(timer);
      timer = null;
    }
    function safeUrl(value) {
      try { const url = new URL(value); return url.protocol === 'https:' ? url.origin + url.pathname : ''; }
      catch (_) { return ''; }
    }
    function routeReady() {
      if (typeof win.gtag !== 'function' || !Array.isArray(win.dataLayer)) return false;
      const loaded = Array.from(doc.scripts).some(script => {
        try { const url = new URL(script.src); return url.origin === 'https://www.googletagmanager.com' && url.pathname === '/gtag/js' && url.searchParams.get('id') === DESTINATION; }
        catch (_) { return false; }
      });
      return loaded && win.dataLayer.some(command => command && command[0] === 'config' && command[1] === DESTINATION);
    }
    function record(event) {
      const form = event.target;
      if (!form || !Object.prototype.hasOwnProperty.call(FORMS, form.id)) return;
      if (committedHandoffs.has(form) && !event.nativeHandoff) return;
      if (event.defaultPrevented || !allowed() || typeof form.checkValidity !== 'function' || !form.checkValidity()) {
        try { win.sessionStorage.removeItem(PREFIX + form.id); } catch (_) {}
        return;
      }
      const formType = form.elements && form.elements.namedItem('form_type');
      if (!formType || formType.value !== 'contact' || String(form.method).toLowerCase() !== 'post') return;
      try {
        const action = new URL(form.action, win.location.href);
        if (action.origin !== win.location.origin || action.pathname !== '/contact') return;
        if (!win.crypto || typeof win.crypto.randomUUID !== 'function') return;
        const marker = {form: form.id, token: win.crypto.randomUUID(), at: Date.now()};
        win.sessionStorage.setItem(PREFIX + form.id, JSON.stringify(marker));
      } catch (_) {}
    }
    function pending(id) {
      if (!allowed()) return null;
      try {
        const marker = JSON.parse(win.sessionStorage.getItem(PREFIX + id) || 'null');
        if (!marker) return null;
        const valid = marker.form === id && typeof marker.token === 'string' && /^[a-f0-9-]{36}$/i.test(marker.token) && typeof marker.at === 'number' && Date.now() >= marker.at && Date.now() - marker.at < TTL && Object.keys(marker).sort().join(',') === 'at,form,token';
        if (!valid) { remove(id); return null; }
        return marker;
      } catch (_) { return null; }
    }
    function check() {
      timer = null;
      if (!allowed()) { if (privacyKnown()) dropAll(); return; }
      const id = win.location.hash.slice(1);
      if (!Object.prototype.hasOwnProperty.call(FORMS, id)) return;
      const form = doc.getElementById(id);
      if (!form) return;
      if (form.querySelector('[data-gccv-lead-error], [data-form-error]')) { remove(id); return; }
      const success = form.querySelector('[data-gccv-lead-success="' + FORMS[id] + '"]');
      if (!success) return;
      const marker = pending(id);
      if (!marker || consumed.has(marker.token)) return;
      if (!routeReady()) {
        if (Date.now() < deadline) timer = win.setTimeout(check, 250);
        return;
      }
      if (!allowed() || !remove(id)) return;
      consumed.add(marker.token);
      const payload = {send_to: DESTINATION, form_type: FORMS[id], submission_status: 'shopify_accepted', page_location: safeUrl(win.location.href), page_referrer: safeUrl(doc.referrer)};
      try { win.gtag('event', 'generate_lead', payload); success.dataset.gccvLeadTracking = 'queued'; }
      catch (_) { success.dataset.gccvLeadTracking = 'unavailable'; }
    }
    function start() {
      deadline = Date.now() + 30000;
      if (timer) win.clearTimeout(timer);
      check();
    }
    function loadPrivacy() {
      if (privacyKnown()) { start(); return; }
      if (requestedPrivacy) return;
      if (!win.Shopify || typeof win.Shopify.loadFeatures !== 'function') { dropAll(); return; }
      requestedPrivacy = true;
      try { win.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => { if (!error && privacyKnown()) start(); else dropAll(); }); }
      catch (_) {}
    }
    Object.keys(FORMS).forEach(id => {
      const form = doc.getElementById(id);
      const original = win.HTMLFormElement && win.HTMLFormElement.prototype.submit;
      if (!form || typeof original !== 'function') return;
      if (form.dataset.hcaptchaBound || form.dataset.recaptchaBound || form.submit !== original) {
        form.dataset.gccvLeadBridge = 'unavailable';
        return;
      }
      const bridge = function () {
        if (this === form) { record({target: form, defaultPrevented: false, nativeHandoff: true}); committedHandoffs.add(form); }
        try { return original.apply(this, arguments); }
        catch (error) {
          if (this === form) { committedHandoffs.delete(form); try { win.sessionStorage.removeItem(PREFIX + id); } catch (_) {} }
          throw error;
        }
      };
      try { form.submit = bridge; form.dataset.gccvLeadBridge = form.submit === bridge ? 'ready' : 'unavailable'; }
      catch (_) { form.dataset.gccvLeadBridge = 'unavailable'; }
    });
    doc.addEventListener('submit', event => { if (event.target) committedHandoffs.delete(event.target); }, true);
    win.addEventListener('submit', record);
    doc.addEventListener('visitorConsentCollected', () => { if (allowed()) start(); else dropAll(); });
    doc.addEventListener('gccv:josh-reset', () => {
      try { win.sessionStorage.removeItem(PREFIX + 'GCCVChatLeadForm'); } catch (_) {}
    }, true);
    win.addEventListener('pageshow', loadPrivacy);
    win.addEventListener('pagehide', () => { if (timer) win.clearTimeout(timer); });
    loadPrivacy();
  }
  if (typeof module === 'object' && module.exports) module.exports = {install};
  else if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => install(window, document), {once: true});
    else install(window, document);
  }
})();
